import { useTenantContext } from '../tenant-context/index.tsx';

export const useDlpEntitlement = (): boolean => {
	const tenantContext = useTenantContext();
	return (tenantContext && tenantContext.hasDlpEnabled) || false;
};
